import React from 'react'
import { Input, Icon } from 'antd'
import './DialogueEditor.scss'

const DialogueEditor = ({ dialogue = {}, onChange, disabled }) => {
  const [isExpanded, setIsExpanded] = React.useState(false)
  const entries = Object.entries(dialogue || {})
  const hasDialogue = entries.length > 0

  return (
    <div
      className={`dialogue-editor-container ${isExpanded ? 'expanded' : ''}`}
    >
      <div className="dialogue-tray">
        <div
          className={`tray-header ${
            hasDialogue && !isExpanded ? 'has-dialogue' : ''
          }`}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <div className="header-title">
            <span>Shot Dialogue</span>
            {hasDialogue && !isExpanded && (
              <span className="dialogue-badge">{entries.length}</span>
            )}
          </div>
          <Icon
            type={isExpanded ? 'up' : 'down'}
            style={{
              fontSize: '12px',
              color: hasDialogue && !isExpanded ? '#1890ff' : '#bfbfbf'
            }}
          />
        </div>
        {isExpanded && (
          <div className="tray-content">
            {hasDialogue ? (
              entries.map(([character, text], index) => (
                <div key={`${character}-${index}`} className="dialogue-item">
                  <span className="character-name">
                    {character.replace(/^__|__$/g, '')}
                  </span>
                  <Input.TextArea
                    className="dialogue-textarea"
                    value={text}
                    disabled={disabled}
                    onChange={e => {
                      const newDialogue = {
                        ...dialogue,
                        [character]: e.target.value
                      }
                      onChange(newDialogue)
                    }}
                    autoSize={{ minRows: 2, maxRows: 4 }}
                  />
                </div>
              ))
            ) : (
              <div className="tray-empty-state">
                <Icon type="info-circle" />
                <span>No dialogue detected for this shot.</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default DialogueEditor
